module.exports = __webpack_public_path__ + "img/C.e22f6288.png";